console.log("script liste depliable");

(function () {

    // ===== LISTE DEPLIABLE =========

    document.querySelectorAll(".containerlist").forEach(function (container) {

        // Etat initial
        container.querySelectorAll(".nodecontent").forEach(function (node) {
            node.classList.add("liens_fond_blanc");
        });

        // Gestion des clics
        container.addEventListener("click", function (e) {

            const node = e.target.closest(".nodecontent");
            if (!node) return;

            const li = node.parentElement;
            const ul = li.parentElement;

            // Affiche le sous niveau
            const childUl = node.nextElementSibling;
            if (childUl && childUl.tagName === "UL") {
                childUl.style.display = "block";
            }

            // Masque les frères
            Array.from(ul.children)
                .filter(el => el !== li)
                .forEach(el => {
                    el.style.display = "none";
                });

            // Classes
            node.classList.remove("liens_fond_blanc");

            node.classList.add(
                "couleur_texte_fond_blanc",
                "containerlist__item__courant",
                "couleur_texte_fond_blanc_hover"
            );

        });

    });


    // ===== RESET =========

    document.querySelectorAll(".bouton1ereQuestion").forEach(function (btn) {

        btn.addEventListener("click", function (e) {

            e.preventDefault();
            e.stopPropagation();

            console.log("annulation de la sélection");

            const resetContainer = btn.closest(".containerlist__lien__reset");
            if (!resetContainer) return;

            [
                resetContainer.previousElementSibling,
                resetContainer.nextElementSibling
            ].forEach(function (container) {

                if (!container || !container.classList.contains("containerlist")) {
                    return;
                }

                // Réafficher les éléments du premier niveau
                container.querySelectorAll(":scope > ul > li").forEach(function (li) {
                    li.style.display = "block";
                });

                // Cacher tous les sous-niveaux
                container.querySelectorAll("ul ul").forEach(function (ul) {
                    ul.style.display = "none";
                });

                // Remettre EXACTEMENT les classes initiales
                container.querySelectorAll(".nodecontent").forEach(function (node) {
                    node.className = "nodecontent liens_fond_blanc";
                });

            });

        });

    });

    // ===== FIN LISTE DEPLIABLE =========

})();